import { animate, frame, motion, useAnimationFrame, useMotionTemplate, useMotionValue, useTransform } from "framer-motion";
import * as React from "react";
import { useRef } from "react";
export const BorderFollower = ({
  children,
  duration = 2000,
  rx,
  ry,
  ...otherProps
}: any) => {
  const pathRef = useRef<SVGRectElement>(null);
  const progress = useMotionValue<number>(0);
  const [isPaused, setIsPaused] = React.useState(false);
  useAnimationFrame((time, delta) => {
    if (isPaused) return;
    const length = pathRef.current?.getTotalLength();
    if (length) {
      const pxPerMillisecond = length / duration;
      //progress.set((time * pxPerMillisecond) % length);
      let newProgress = (progress.get() + delta * pxPerMillisecond) % length;
      if (newProgress > length) {
        newProgress -= length;
      }
      progress.set(newProgress);
    }
  });
  const getVal = (val: number) => {
    const length_0 = pathRef.current?.getTotalLength();
    if (!length_0) return val;
    while (val < 0) {
      val += length_0;
    }
    while (val > length_0) {
      val -= length_0;
    }
    return val;
  };
  const x = useTransform(progress, val_0 => pathRef.current?.getPointAtLength(getVal(val_0)).x);
  const y = useTransform(progress, val_1 => pathRef.current?.getPointAtLength(getVal(val_1)).y);
  const transform = useMotionTemplate`translateX(${x}px) translateY(${y}px) translateX(-50%) translateY(-50%)`;
  return <>
      <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%" {...otherProps} onMouseEnter={() => {
      setIsPaused(true);
    }} onMouseLeave={e => {
      setIsPaused(false);
    }} onMouseMove={e_0 => {
      const path = pathRef.current;
      if (!path) return;
      const target = e_0.currentTarget;
      let rect: DOMRect;
      let mouseX: number, mouseY: number, totalLength: number;
      frame.read(() => {
        rect = target.getBoundingClientRect();
        totalLength = path.getTotalLength();
      });

      // Set a large initial value for the closest distance
      let closestDistance = Infinity;
      let closestLength = 0;
      // Set initial values for the closest point
      let closestPoint = {
        x: 0,
        y: 0
      };
      frame.update(() => {
        mouseX = e_0.clientX - rect.left;
        mouseY = e_0.clientY - rect.top;

        // Iterate through points on the path and find the closest point
        for (var i = 0; i < totalLength; i += 1) {
          var point = path.getPointAtLength(i);

          // Calculate the distance between the mouse cursor and the current point
          var distance = Math.sqrt(Math.pow(point.x - mouseX, 2) + Math.pow(point.y - mouseY, 2));

          // Check if the current point is closer than the previous closest point
          if (distance < closestDistance) {
            closestDistance = distance;
            closestPoint = point;
            closestLength = i;
          }
        }
      });
      frame.render(() => {
        const currentLength = progress.get();
        const currentProgress = currentLength / totalLength;
        const closestProgress = closestLength / totalLength;
        if (closestProgress - currentProgress > 0.5) {
          closestLength -= totalLength;
        } else if (currentProgress - closestProgress > 0.5) {
          closestLength += totalLength;
        }
        animate(progress, closestLength, {
          type: "tween",
          duration: 0.1
        });
        //progress.set(closestLength);
        //x.set(closestPoint.x);
        //y.set(closestPoint.y);
      });
    }}>
        <rect fill="none" width="100%" height="100%" rx={rx} ry={ry}
      // @ts-ignore
      ref={pathRef} />
      </svg>
      <motion.div className="pointer-events-none absolute left-0 top-0 inline-block" style={{
      transform
    }}>
        {children}
      </motion.div>
    </>;
};